<template>
  <v-footer height="60" class="mt-5 justify-center text-xs-center d-block">
    <v-row align="center" justify="center">
      <div class="mt-2">
        &copy; {{ new Date().getFullYear() }} made with
        <v-icon small class="red--text mx-0 px-0">mdi-cards-heart</v-icon>&nbsp;by: TPAY Integration Team
      </div>
    </v-row>
  </v-footer>
</template>

<script>
export default {};
</script>

<style>
</style>